// extracted by mini-css-extract-plugin
export default {"wrap":"Qs-z","melodyCategory":"Rs-z","fullWidth":"Ss-z","items":"Ts-z","featureCss":"Us-z","disabled":"Vs-z","imgCss":"Ws-z"};